import { Star } from "lucide-react";

const testimonials = [
  {
    quote: "Great experience. Dan can be trusted with all your web projects and all things digital. I trust him and value his expertise, guidance, and knowledge.",
    source: "Client via Upwork",
    rating: 5,
  },
  {
    quote: "I wouldn't hesitate to hire him again!",
    source: "Client via Upwork",
    rating: 5,
  },
  {
    quote: "Dan answered my job request quickly, he explained things well, he explained questions and described the tasks very descriptive.",
    source: "Client via Upwork",
    rating: 5,
  },
];

const TestimonialsSection = () => {
  return (
    <section className="py-16 border-t border-border" aria-labelledby="testimonials-title">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <h2 id="testimonials-title" className="text-3xl md:text-4xl font-bold mb-4">
            What Our Clients Say
          </h2>
          <p className="text-muted-foreground text-lg">
            Real feedback from founders who chose speed and results.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-secondary/50 border border-border ring-1 ring-white/[0.08] dark:ring-white/[0.12] rounded-lg p-6 animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-primary text-primary" />
                ))}
              </div>
              <blockquote className="text-foreground mb-4 leading-relaxed italic">
                "{testimonial.quote}"
              </blockquote>
              <p className="text-sm text-muted-foreground">{testimonial.source}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
